// This will list all the scene available to the user depending on its rights

import React, { createContext, useState } from "react";

// Seed to be replace by a service here
const sceneListSeed = [
  {
    id: 'id scene nsldknfs;lkfdnen',
    name: 'Scene name a',
    version: '1.0.2',
    type: 'prod'
  },
  {
    id: 'id scenergesrgesen',
    name: 'Scene name b',
    version: '1.0.3',
    type: 'dev'
  },
  {
    id: 'id scene nslsernen',
    name: 'Scene name c',
    version: '0.0.3',
    type: 'prod'
  },
]

export const SceneContext = createContext();

export const SceneProvider = ({ children }) => {
  const [sceneList, setSceneList] = useState(sceneListSeed);

  return (
    <SceneContext.Provider value={{ sceneList, setSceneList }}>
      {children}
    </SceneContext.Provider>
  );
};
